<template>
  <footer v-if="!isSplitPanel" class="p-4">
    <!-- COPYRIGHT © 2024, All rights Reserved -->
  </footer>
</template>

<script setup lang="ts">
defineProps({
  isSplitPanel: {
    type: Boolean,
    default: false,
  },
});
</script>
